// each line location in terms of 360 degree
const points = [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330]

interface SpinnerProps {
  className?: string
  divClassName?: string
}

const Spinner: React.FC<SpinnerProps> = ({
  className = '',
  divClassName = '',
}) => {
  return (
    <div className={`flex justify-center items-center h-full ${divClassName}`}>
      <svg
        className={`animate-loader-spin stroke-grey ${className}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="70%"
        data-testid="rotating-lines-svg"
        aria-label={'rotating-lines-loading'}
      >
        {points.map((point) => (
          <polyline
            className="[&:nth-child(1)]:opacity-[0.08] [&:nth-child(2)]:opacity-[0.16] [&:nth-child(3)]:opacity-[0.24] [&:nth-child(4)]:opacity-[0.32] [&:nth-child(5)]:opacity-[0.40] [&:nth-child(6)]:opacity-[0.48] [&:nth-child(7)]:opacity-[0.56] [&:nth-child(8)]:opacity-[0.64] [&:nth-child(9)]:opacity-[0.72] [&:nth-child(10)]:opacity-[0.80] [&:nth-child(11)]:opacity-[0.88] [&:nth-child(12)]:opacity-[0.96]"
            key={point}
            points="24,14 24,6"
            transform={`rotate(${point}, 24, 24)`}
            strokeLinecap="round"
            strokeWidth="2.5px"
          />
        ))}
      </svg>
    </div>
  )
}

export default Spinner
